import { translate } from "@/config/translator";
// eslint-disable-next-line max-len
import { useNotificationsMobileTopBar } from "./notificationsMobileTopBar/useNotificationsMobileTopBar";
import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";

export function NotificationsMobileTopBar() {
  const { onBack, lang } = useNotificationsMobileTopBar();

  return (
    <TopBarMobile
      onBack={onBack}
      headerString={translate("notifications", lang)}
    />
  );
}
